export default "__VITE_ASSET__vQBqrcaa__"